import { FichaCadastro } from './../../ficha-veiculo/ficha-cadastro/ficha-cadastro';
import { PesadosBrasilStorage } from './../../services/pesados-brasil/pesados-brasil.storage';
import { Originador } from './../../services/pesados-brasil/originador.interface';
import { AgenteEndereco } from '../../services/pesados-brasil/agente-endereco.interface';
import { LoginStorage } from './../../login/login.storage';

import { take, takeWhile, finalize } from 'rxjs/operators';
import { Component, forwardRef, Input, OnInit, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { CepService } from './../../services/cep/cep.service';
import { EnderecoCep } from './../../services/cep/endereco-cep';
import { EnderecoMultiplo } from './../../services/cep/endereco-multiplo';
import { UfCidadeSelectComponent } from './../uf-cidade-select/uf-cidade-select.component';
import { NewModalMessageComponent } from './../modais/new-modal-message/new-modal-message.component';
import { CustomModalService } from '../../shared/modais/custom-modal/custom-modal.service';
import { appSettings } from '../../../environments/app.setings';
import { ModalMultiplosEnderecosComponent } from './modal-multiplos-enderecos/modal-multiplos-enderecos.component';
import { ModalEncontrarCepComponent } from './modal-encontrar-cep/modal-encontrar-cep.component';
import { ModalMessageComponent } from '../modais/modal-message/modal-message.component';
import { AgenteService } from './../../services/pesados-brasil/agente.service';

@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  styleUrls: ['./endereco.component.css'],
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EnderecoComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EnderecoComponent),
      multi: true,
    },
  ]
})
export class EnderecoComponent implements OnInit, Validator, ControlValueAccessor, OnChanges {

  @Input() icon: string;
  @Input() label: string;
  @Input() fichaCadastroPasso: number;
  @Input() isEnderecoPesadoBrasil: boolean = false;
  @Input() cep;
  @Input() fichaCadastro: FichaCadastro;

  public endereco: any = {};

  @ViewChild('appUfCidade', { static: true }) appUfCidade: UfCidadeSelectComponent;
  @ViewChild('modalErro', { static: false }) modalErro: NewModalMessageComponent;
  @ViewChild('modalMessage', { static: true }) modalMessage: ModalMessageComponent;

  public isBuscandoCep = false;
  public hasLogradouro: boolean = false;
  public hasBairro: boolean = false;
  cepErrorStatus: any;
  public isAgentePesadosBr;
  public agenteEndereco: AgenteEndereco;
  public originador: Originador;
  public primeiraVez = true;

  constructor(
    private cepService: CepService,
    private changeDetectorRef: ChangeDetectorRef,
    private modal: CustomModalService,
    private agenteService: AgenteService,
    private loginStorage: LoginStorage,
    private pesadosBrasilStorage: PesadosBrasilStorage,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.fichaCadastroPasso && this.fichaCadastroPasso === 12 && this.primeiraVez) {
      this.primeiraVez = false;
      this.handleEnderecoStorage();
    }
    if (this.fichaCadastro && this.fichaCadastro.shouldSearchAddress) {
      this.fichaCadastro.shouldSearchAddress = false;
      this.onCepExit();
    }
    if (this.cep) {
      this.endereco.cep = this.cep;
    }
  }

  ngOnInit() {
    this.originador = this.loginStorage.originator;
    if (this.originador) {
      this.isAgentePesadosBr = this.originador.originador;
    }
  }

  onChange() {
    this.endereco.cep = (this.endereco.cep || '').replace('-', '');
    this.propagateChange(this.endereco);
    this.changeDetectorRef.detectChanges();
  }

  handleEnderecoStorage() {
    if (this.pesadosBrasilStorage.enderecoTotal) {
      const res = this.pesadosBrasilStorage.enderecoTotal;
      if (this.pesadosBrasilStorage.enderecoTotal && this.pesadosBrasilStorage.enderecoTotal.enderecos && this.pesadosBrasilStorage.enderecoTotal.enderecos.length === 1) {
        const endereco = new EnderecoCep(res);
        this.handleFindEnderecoCep(endereco);
        if (this.originador.originador && this.isEnderecoPesadoBrasil) {
          this.getCEPAgente();
        }
      } else if (this.pesadosBrasilStorage.enderecoTotal && this.pesadosBrasilStorage.enderecoTotal.enderecos && this.pesadosBrasilStorage.enderecoTotal.enderecos.length > 1) {
        this.handleMultiplosEnderecos(res.enderecos);
      }
    }

  }

  onCepExit() {
    if (this.endereco.cep) {
      this.isBuscandoCep = true;
      this.cepService
        .getEnderecoByCep(this.endereco.cep.replace('-', ''))
        .pipe(
          finalize(() => this.isBuscandoCep = false),
          take(1)
        )
        .subscribe(
          (res) => {
            if (res.enderecos.length === 1) {
              const endereco = new EnderecoCep(res);
              this.handleFindEnderecoCep(endereco);
              this.pesadosBrasilStorage.registerEnderecoTotal(res);
              if (this.originador.originador && this.isEnderecoPesadoBrasil) {
                this.getCEPAgente();
              }
              return;
            }
            this.handleMultiplosEnderecos(res.enderecos);
          },
          (err) => {
            this.endereco = {};
            this.modalMessage.show(err.error.message);
          }
        );
    }
  }

  getCEPAgente() {
    if (this.endereco.cep) {
      this.cepErrorStatus = null;
      this.isBuscandoCep = true;
      this.agenteService
        .getEnderecoAgentePorCep(this.endereco.cep.replace('-', ''), this.originador.typesOrigination[0].code)
        .pipe(
          finalize(() => this.isBuscandoCep = false),
          take(1),
        )
        .subscribe(
          (res) => {
            this.agenteEndereco = res;
            this.pesadosBrasilStorage.registerAgenteEndereco(res);
          },
          (error) => {
            this.cepErrorStatus = error.status;
          }
        );
    }
  }

  handleMultiplosEnderecos(enderecos: EnderecoMultiplo) {
    this.endereco = {};

    const initialState = { listaEnderecos: enderecos };
    const modal = this.modal.show(ModalMultiplosEnderecosComponent, { ...appSettings.MODAL_PARAMS, initialState });

    const modalMultiplosEnderecos = <ModalMultiplosEnderecosComponent>modal.content;

    modalMultiplosEnderecos.closeModal
      .pipe(
        takeWhile(() => modalMultiplosEnderecos.alive)
      )
      .subscribe((res) => {
        if (res) {
          const endereco = new EnderecoMultiplo(res);
          this.handleFindEnderecoCep(endereco);
          if (this.originador.originador && this.isEnderecoPesadoBrasil) {
            this.getCEPAgente();
          }
        }
      });
  }

  onClickFindCep() {
    const initialState = {};
    const modal = this.modal.show(ModalEncontrarCepComponent, { ...appSettings.MODAL_PARAMS, initialState });

    const modalEncontrarCep = <ModalEncontrarCepComponent>modal.content;

    modalEncontrarCep.closeModal
      .pipe(
        takeWhile(() => modalEncontrarCep.alive)
      )
      .subscribe((res) => {
        if (res) {
          const endereco = new EnderecoCep(res);
          this.handleFindEnderecoCep(endereco);
        }
      });
  }

  validate(): { [key: string]: any; } {
    return this.isValid ? null : { valid: false };
  }

  get isValid(): boolean {
    return this.endereco.endereco &&
      this.endereco.uf &&
      this.endereco.cidade &&
      this.endereco.bairro &&
      this.endereco.numero &&
      this.endereco.numero.length > 0 &&
      this.endereco.cep;
  }

  private handleFindEnderecoCep(res) {
    this.hasLogradouro = res.logradouro !== '';
    this.hasBairro = res.bairro !== '';

    this.endereco = {};

    if (res.logradouro) {
      this.endereco.endereco = res.logradouro;
    }

    if (res.uf) {
      this.endereco.uf = res.uf;
    }

    if (res.cidade) {
      this.endereco.cidade = res.cidade;
    }

    if (res.bairro) {
      this.endereco.bairro = res.bairro;
    }

    if (res.numero) {
      this.endereco.numero = res.numero;
    } else if (this.fichaCadastro && this.fichaCadastro._client && this.fichaCadastro._client.enderecos && this.fichaCadastro._client.enderecos.numero) {
      this.endereco.numero = this.fichaCadastro && this.fichaCadastro._client && this.fichaCadastro._client.enderecos.numero;
    }

    if (this.fichaCadastro && this.fichaCadastro._client && this.fichaCadastro._client.enderecos && this.fichaCadastro._client.enderecos.complemento) {
      this.endereco.complemento = this.fichaCadastro && this.fichaCadastro._client && this.fichaCadastro._client.enderecos.complemento;
    }

    if (res.cep) {
      this.endereco.cep = res.cep;
    }

    this.refresh();
  }

  refresh() {
    if (this.endereco.uf) {
      this.appUfCidade.refreshCidades(this.endereco.uf);
    }
  }

  public writeValue(obj: any) {
    if (obj) {
      this.endereco = obj;
      this.refresh();
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() {
    // This is intentional
  }

  private propagateChange = (_: any) => {
    // This is intentional
  }
}
